import axios from 'axios';
import Cookies from 'js-cookie';
import authService from './authService';

// Set default base URL for all axios requests
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

// Add a request interceptor to add the token to requests
axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get('accessToken');
    // Do not add token to refresh token requests
    if (token && !config.url.includes('/token/refresh')) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token refresh
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't tried to refresh the token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Attempt to refresh the token
        const newAccessToken = await authService.refreshToken();
        
        // Retry the original request with the new token
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        // If refresh fails, logout the user
        authService.logout();
        window.location.href = '/auth'; // Redirect to login page
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
